import React from 'react';

import styles from './NotFound.module.css'; // Créez ce fichier de style
import Button from '../components/common/Button/Button';

function NotFound() {
  return (
    <section className={styles.notFound}>
      <div className={styles.content}>
        <h1>404</h1>
        <p>Oups ! La page que vous cherchez n'existe pas.</p>
        <p>Il semblerait que vous vous soyez égaré dans la forêt du code.</p>
        <Button to="/" variant="primary">Retour à l'accueil</Button>
      </div>
    </section>
  );
}

export default NotFound;
